import { SettingsManager } from '@shared/app/scripts/services/settings-manager';
import { FiscalPrinter } from '@shared/app/scripts/services/fiscal-printer';
import { Sales } from '@shared/app/scripts/services/sales';

/*
 * Service reprintReceipt
 */
angular
  .module('posApp')
  .factory(
    'reprintReceipt',
    (
      legacyPrint,
      pos,
      fiscalPrinter: FiscalPrinter,
      printCoupon,
      sales: Sales,
      settingsManager: SettingsManager,
    ) => {
      // TODO move this logic to the fiscalPrinter service in v7/shared
      const reprintReceipt = (transaction = null, isReprint = true) => {
        if (!transaction) {
          transaction = pos.transaction;
        }

        // Handle coupons for first-time prints (save-twice pattern)
        if (!isReprint) {
          printCoupon(transaction);
        }

        if (settingsManager.settings.fiscalPrinter?.active) {
          if (transaction.fiscal_receipt_nr) {
            return fiscalPrinter
              .login()
              .then(() => fiscalPrinter.reprint(transaction));
          } else if (transaction.return_original_nr) {
            return sales
              .filter({ nr: transaction.return_original_nr })
              .then(([originalTransaction]) => {
                return fiscalPrinter
                  .return(transaction, originalTransaction)
                  .then(
                    ({
                      fiscalReceiptNumber,
                      fiscalShiftNumber,
                      fiscalDate,
                    }) => {
                      return sales.addFiscalReceipt(
                        transaction._id,
                        fiscalReceiptNumber,
                        fiscalShiftNumber,
                        fiscalDate,
                        settingsManager.settings.fiscalPrinter?.printerId,
                      );
                    },
                  );
              });
          } else {
            return fiscalPrinter
              .receipt(transaction)
              .then(
                ({ fiscalReceiptNumber, fiscalShiftNumber, fiscalDate }) => {
                  return sales.addFiscalReceipt(
                    transaction._id,
                    fiscalReceiptNumber,
                    fiscalShiftNumber,
                    fiscalDate,
                    settingsManager.settings.fiscalPrinter?.printerId,
                  );
                },
              );
          }
        } else {
          return legacyPrint.receipt(transaction, isReprint);
        }
      };

      return reprintReceipt;
    },
  );
